<!-- Select Template to Show -->
<ng-container [ngTemplateOutlet]="bannerTemplate">
	<!-- ... using the selected template in here -->
</ng-container>

<!-- ========================================================= -->
<!-- Discount Banner Type -->
<ng-template #bannerTypeDiscount>
	<div class="d-flex justify-content-center align-items-center">
		<img
			[src]="bannerTheme.content.mascot"
			[width]="imgWidthInPx"
		/>

		<!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -->
		<div
			class="d-flex flex-column align-items-start"
			[style.width.px]="textWidthInPx"
		>
			<span class="text-white text-start h3 ms-2 larger-font-size">
				{{ bannerTheme?.content.text }}
			</span>
			<ng-container *ngIf="bannerTheme?.content?.couponCode">
				<span class="text-white text-start h3 ms-2 mb-0 smaller-font-size">
					USE {{ bannerTheme?.content.couponCode }}
				</span>
				<span class="text-white text-start h3 ms-2 mb-0 smaller-font-size">
					{{ bannerTheme?.content.couponDiscount }}% OFF
				</span>
				<small class="text-white ms-2 x-small-font-size">Valid till {{ validity | date: 'dd.MM.yyyy' }}</small>
			</ng-container>
		</div>
	</div>
</ng-template>

<!-- Mascot Banner Type -->
<ng-template #bannerTypeMascot>
	<div class="d-flex justify-content-center align-items-center">
		<img
			[src]="bannerTheme.content.mascot"
			width="100px"
		/>
	</div>
</ng-template>

<!-- Discount Banner Type -->
<ng-template #bannerTypeMessage>
	<div class="d-flex justify-content-center align-items-center">
		<img
			[src]="bannerTheme.content.mascot"
			width="100px"
		/>

		<div class="d-flex flex-column align-items-start">
			<span class="text-white text-start h3 ms-2 larger-font-size discount-banner-content-width">
				{{ bannerTheme?.content.text }}
			</span>
		</div>
	</div>
</ng-template>
